import React from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from '../../elements/list/DeleteButton';

export default class CustomerGroups extends React.Component {
  render() {
    return (
      <div className="credit-card-management">
        <div className="activated-cards">
          {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
          <div className="dark-blur"></div>
          <div className="box-header">
            <h2><i className="fa fa-bell"></i> Customer Groups </h2>
          </div>
          <form style={{ paddingLeft: '15px', paddingRight: '15px', position: 'relative', marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '100%' }}>
              <input type="search" style={{ maxWidth: '25%', marginRight: '20px' }} placeholder="Search" />
              <button type="submit" className="button-round width-180">Apply</button>
            </div>
            <Link to="/push-notifications/customer-groups/add-new"><button type="button" className="button-round width-180">Add New</button></Link>
          </form>
          <div className="box-body">
            <table className="table">
              <tbody>
                <tr className="tr-dark-bg">
                  <td style={{ width: '10%' }}>Id</td>
                  <td>Name</td>
                  <td>Subscriber count</td>
                  <td>Pushes sent</td>
                  {/* <td></td> */}
                  <td align="center" style={{ width: '20%' }}>Actions</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>All Users</td>
                  <td>3611</td>
                  <td>10800</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Users with inactive cards</td>
                  <td>240</td>
                  <td>945</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Last login date 3 months ago</td>
                  <td>50</td>
                  <td>100</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Non verified users</td>
                  <td>679</td>
                  <td>0</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/push/CustomerGroups.js